import React, { useState, useEffect } from 'react';
import {
  SortingState, EditingState, PagingState, SummaryState,
  IntegratedPaging, IntegratedSorting, IntegratedSummary,
} from '@devexpress/dx-react-grid';
import {
  Grid, Table, TableHeaderRow, TableEditRow, TableEditColumn,
  DragDropProvider, TableColumnReordering, TableSummaryRow,
} from '@devexpress/dx-react-grid-bootstrap4';
import "react-datepicker/dist/react-datepicker.css";
import { Getter } from "@devexpress/dx-react-core";
import { Card } from 'reactstrap';
import SettingService from '../../services/Settings/SettingService'
import { BACKEND_URL } from "../../services/backendURL";
import { Loading } from '../HumanResources/loading';

const CommandButton = ({ onExecute, icon, text, hint, color }) => (
  <button
    type="button"
    className="btn btn-link"
    style={{ padding: 11 }}
    onClick={(e) => {
      onExecute();
      e.stopPropagation();
    }}
    title={hint} >
    <span className={color || 'undefined'}>
      {icon ? <i className={`bx bx-${icon}`} style={{ marginRight: text ? 5 : 0, fontSize: 20 }} /> : null}
      {text}
    </span>
  </button>
);

const AddButton = ({ onExecute }) => (
  <CommandButton icon="plus" hint="Create new row" color="text-info" onExecute={onExecute} />
);

const EditButton = ({ onExecute }) => (
  <CommandButton icon="pencil" hint="Edit row" color="text-warning" onExecute={onExecute} />
);

const DeleteButton = ({ onExecute }) => (
  <CommandButton
    icon="trash"
    hint="Delete row"
    color="text-danger"
    onExecute={() => {
      onExecute();
    }}
  />
);

const CommitButton = ({ onExecute }) => (
  <CommandButton icon="check" hint="Save changes" color="text-success" onExecute={onExecute} />
);

const CancelButton = ({ onExecute }) => (
  <CommandButton icon="x" hint="Cancel changes" color="text-danger" onExecute={onExecute} />
);

const commandComponents = {
  add: AddButton,
  edit: EditButton,
  delete: DeleteButton,
  commit: CommitButton,
  cancel: CancelButton,
};

const Command = ({ id, onExecute }) => {
  const ButtonComponent = commandComponents[id];
  return (
    <ButtonComponent
      onExecute={onExecute}
    />
  );
};

const Cell = (props) => {
  // const { column } = props;
  return <Table.Cell {...props} />;
};

const EditCell = (props) => {
  return <TableEditRow.Cell {...props} />;
};

const getRowId = row => row.id;

export default (input) => {
  const [columns] = useState([
    { name: 'name', title: 'Titulli' },
    { name: 'description', title: 'Përshkrimi' },
    { name: 'points', title: 'Pikët' },
  ]);
  const [rows, setRows] = useState([]);
  const [tableColumnExtensions] = useState([
    { columnName: 'name', width: "40%" },
    { columnName: 'description', width: "40%" },
    { columnName: 'points', width: "20%" },
  ]);
  const [sorting, getSorting] = useState([]);
  const [editingRowIds, getEditingRowIds] = useState([]);
  const [addedRows, setAddedRows] = useState([]);
  const [rowChanges, setRowChanges] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(0);
  const [loading, setLoading] = useState(false);
  const [columnOrder, setColumnOrder] = useState(['name', 'description', 'points']);
  const [totalSummaryItems] = useState([
    { columnName: 'discount', type: 'avg' },
    { columnName: 'amount', type: 'sum' },
  ]);
  const [lastQuery, setLastQuery] = useState();
  const changeAddedRows = value => setAddedRows(
    value.map(row => (Object.keys(row).length ? row : {
    })),
  );

  const deleteRows = (deletedIds) => {
    const rowsForDelete = rows.slice();
    deletedIds.forEach((rowId) => {
      const index = rowsForDelete.findIndex(row => row.id === rowId);
      if (index > -1) {
        rowsForDelete.splice(index, 1);
      }
    });
    return rowsForDelete;
  };

  const commitChanges = ({ added, changed, deleted }) => {
    let changedRows;
    if (added) {
      SettingService.createRow(BACKEND_URL + input["endpoint"] + "/", {
        name: added[0].name,
        description: added[0].description,
      })
        .then(response => {
            changedRows = [
              ...rows,
              ...added.map((row, index) => ({
                id: response.data.id,
                ...row,
              })),
            ];
            setRows(changedRows);
        })
        .catch(error => { })
    }
    if (changed) {
      changedRows = rows.map(row => (changed[row.id] ? { ...row, ...changed[row.id] } : row));
      let ind = Object.keys(changed)[0]

      if (changed[ind]) {
        var row = rows.filter(opt => { return String(opt.id)===String(ind)})[0]

        let updated = {
          name: changed[ind].name ? changed[ind].name : row.name,
          description: changed[ind].description ? changed[ind].description : row.description,
        }

        SettingService.updateRow(BACKEND_URL + input["endpoint"] + "/", {id:ind}, updated)
        .then(response => {
          setRows(changedRows);
        })
        .catch(error => { })
      }
    }
    if (deleted) {
      changedRows = deleteRows(deleted);

      SettingService.deleteRow(BACKEND_URL + input["endpoint"] + "/", {id:deleted[0]})
      .then(response => {
        setRows(changedRows);
      })
      .catch(error => {})
    }
  };

  const getQueryString = () => {
    return `${BACKEND_URL + input["endpoint"]}`;
  };

  const loadData = () => {
    const queryString = getQueryString();

    if (queryString !== lastQuery && !loading) {
      setLoading(true);
      SettingService.readRows(queryString).then(response => {
        setRows(response.data)
        setLoading(false);
      }).catch(error => {
        setLoading(false);
      })
      setLastQuery(queryString);
    }
  };

  useEffect(() => { loadData() });

  return (
    <Card>
      <Grid
        rows={rows}
        columns={columns}
        getRowId={getRowId}
      >
        <SortingState
          sorting={sorting}
          onSortingChange={getSorting}
        />
        <PagingState
          currentPage={currentPage}
          onCurrentPageChange={setCurrentPage}
          pageSize={pageSize}
          onPageSizeChange={setPageSize}
        />
        <EditingState
          editingRowIds={editingRowIds}
          onEditingRowIdsChange={getEditingRowIds}
          rowChanges={rowChanges}
          onRowChangesChange={setRowChanges}
          addedRows={addedRows}
          onAddedRowsChange={changeAddedRows}
          onCommitChanges={commitChanges}
        />
        <SummaryState
          totalItems={totalSummaryItems}
        />
        <IntegratedSorting />
        <IntegratedPaging />
        <IntegratedSummary />
        <DragDropProvider />
        <Table
          columnExtensions={tableColumnExtensions}
          cellComponent={Cell}
          messages={{noData :"Nuk ka të dhëna"}}
        />
        <TableColumnReordering
          order={columnOrder}
          onOrderChange={setColumnOrder}
        />
        <TableHeaderRow showSortingControls />
        <TableEditRow
          cellComponent={EditCell}
        />
        <TableEditColumn
          width={120}
          showAddCommand={!addedRows.length}
          showEditCommand={true}
          showDeleteCommand={true}
          commandComponent={Command}
        />
        <TableSummaryRow />
        <Getter
          name="tableColumns"
          computed={({ tableColumns }) => {
            const result = [
              ...tableColumns.filter(c => c.type !== TableEditColumn.COLUMN_TYPE),
              { key: 'editCommand', type: TableEditColumn.COLUMN_TYPE, width: 140 }
            ];
            return result;
          }}
        />  
      </Grid>
      {loading && <Loading />}
    </Card>
  );
};
